<script>
  import { BeerButton } from '@xhs/yam-beer'

  export default {
    name: 'BeerResetButton',

    components: {
      BeerButton,
    },

    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['click'],

    methods: {
      emitClick() {
        this.$emit('click')
      },
    },
  }
</script>

<template>
  <beer-button
    :disabled="disabled"
    type="secondary"
    variant="secondary"
    @click="emitClick"
  >
    <slot />
  </beer-button>
</template>
